import { Component } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-found-component',
  imports: [RouterLink],
  templateUrl: './not-found-component.component.html',
  styleUrl: './not-found-component.component.scss'
})
export class NotFoundComponentComponent {

}
